// Festivos: nacionales (iguales en toda España, se calculan) + los de cada clínica (autonómicos y locales),
// que se ponen en la ficha de la clínica («Mi clínica» → Festivos). Igual que functions/bot/conocimiento.js.
import { CLINICAS } from './clinicas';

function pascua(y) {
  const a = y % 19, b = Math.floor(y / 100), c = y % 100, d = Math.floor(b / 4), e = b % 4, f = Math.floor((b + 8) / 25), g = Math.floor((b - f + 1) / 3);
  const h = (19 * a + b - d - g + 15) % 30, i = Math.floor(c / 4), k = c % 4, l = (32 + 2 * e + 2 * i - h - k) % 7, m = Math.floor((a + 11 * h + 22 * l) / 451);
  const mes = Math.floor((h + l - 7 * m + 114) / 31), dia = ((h + l - 7 * m + 114) % 31) + 1;
  return new Date(Date.UTC(y, mes - 1, dia));
}
const FIJOS = { '01-01': 'Año Nuevo', '01-06': 'Reyes', '05-01': 'Día del Trabajo', '08-15': 'Asunción', '10-12': 'Fiesta Nacional', '11-01': 'Todos los Santos', '12-06': 'Día de la Constitución', '12-08': 'Inmaculada', '12-25': 'Navidad' };

export function festivoNacional(dia) {
  if (FIJOS[dia.slice(5)]) return FIJOS[dia.slice(5)];
  const vs = pascua(+dia.slice(0, 4)); vs.setUTCDate(vs.getUTCDate() - 2);
  return vs.toISOString().slice(0, 10) === dia ? 'Viernes Santo' : null;
}

export const festivo = (clinica, dia) => CLINICAS.find((c) => c.id === clinica)?.festivos?.[dia] || festivoNacional(dia) || null;
